import { Component, createSignal } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import SelectorCard from "../elements/SelectorCard";
import HeaderModal from "../elements/HeaderModal";

// import icons
import BuilderIcon from "../assets/icons/builderIcon.svg";
import WordPressIcon from "../assets/icons/wordpressIcon.svg";
import MailingBossIcon from "../assets/icons/mbIcon.svg";
import AssociateIcon from "../assets/icons/associateIcon.svg";
import EmailIcon from "../assets/icons/emailIcon.svg";
import ElearningIcon from "../assets/icons/elearningIcon.svg";

import Styles from "bundle-text:../styles/_toolSelectorModal.scss";
import { translations as t } from "../../../services/context";

interface ToolSelectorModalProps {
  show: boolean;
  onClose: () => void;
  onNext?: (tool: string) => void;
}

const ToolSelectorModal: Component<ToolSelectorModalProps> = (props) => {
  const tools = [
    {
      icon: BuilderIcon,
      bgColor: "#EE8D00",
      title: t["dns_builder_title"],
      text: t["dns_builder_desc"],
      active: true,
      tool: "website-builder",
    },
    {
      icon: WordPressIcon,
      bgColor: "#2560DE",
      title: t["dns_wordpress_title"],
      text: t["dns_wordpress_desc"],
      active: true,
      tool: "wordpress",
    },
    {
      icon: MailingBossIcon,
      bgColor: "#0060E3",
      title: t["dns_mb_title"],
      text: t["dns_mb_desc"],
      active: true,
      tool: "mailing-boss",
    },
    {
      icon: AssociateIcon,
      bgColor: "#0060E3",
      title: t["dns_associate_title"],
      text: t["dns_associate_desc"],
      active: true,
      tool: "associate",
    },
    {
      icon: EmailIcon,
      bgColor: "#01D4B9",
      title: t["dns_email_title"],
      text: t["dns_email_desc"],
      active: true,
      tool: "email",
    },
    {
      icon: ElearningIcon,
      bgColor: "#EE8D00",
      title: t["dns_elearning_title"],
      text: t["dns_elearning_desc"],
      active: true,
      tool: "elearning",
    },
  ];
  const [selectedTool, setSelectedTool] = createSignal(null);

  const handleToolSelect = (tool) => {
    setSelectedTool(tool);
  };

  const handleNext = () => {
    props.onNext?.(selectedTool()?.tool);
    setSelectedTool(null);
  };

  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show}>
        <HeaderModal
          title={t["dns_tools_title"]}
          onClose={() => props.onClose?.()}
        />

        <div class="tool-selector-modal">
          {tools.map((tool) => (
            <SelectorCard
              icon={tool.icon}
              bgColor={tool.bgColor}
              title={tool.title}
              text={tool.text}
              active={tool.active}
              selected={selectedTool() === tool && tool.active}
              onSelect={() => tool.active && handleToolSelect(tool)}
            />
          ))}
        </div>

        <div class="modal-footer">
          <button class="btn-next" onClick={handleNext}>
            {t["dns_general_next"]}
          </button>
        </div>
      </DefaultModal>
    </>
  );
};

export default ToolSelectorModal;
